export default {
  GET_EVENTS_DATA: 'GET_EVENTS_DATA',
  GET_EVENTS_DATA_REQUEST: 'GET_EVENTS_DATA_REQUEST',
  GET_EVENTS_DATA_SUCCESS: 'GET_EVENTS_DATA_SUCCESS',
  GET_EVENTS_DATA_FAILURE: 'GET_EVENTS_DATA_FAILURE',

  GET_EVENT_DATA_BY_ID: 'GET_EVENT_DATA_BY_ID',
  GET_EVENT_DATA_BY_ID_REQUEST: 'GET_EVENT_DATA_BY_ID_REQUEST',
  GET_EVENT_DATA_BY_ID_SUCCESS: 'GET_EVENT_DATA_BY_ID_SUCCESS',
  GET_EVENT_DATA_BY_ID_FAILURE: 'GET_EVENT_DATA_BY_ID_FAILURE',

  POST_EVENT_DATA: 'POST_EVENT_DATA',
  POST_EVENT_DATA_REQUEST: 'POST_EVENT_DATA_REQUEST',
  POST_EVENT_DATA_SUCCESS: 'POST_EVENT_DATA_SUCCESS',
  POST_EVENT_DATA_FAILURE: 'POST_EVENT_DATA_FAILURE',

  PUT_EVENT_DATA: 'PUT_EVENT_DATA',
  PUT_EVENT_DATA_REQUEST: 'PUT_EVENT_DATA_REQUEST',
  PUT_EVENT_DATA_SUCCESS: 'PUT_EVENT_DATA_SUCCESS',
  PUT_EVENT_DATA_FAILURE: 'PUT_EVENT_DATA_FAILURE',

  DELETE_EVENT_DATA_BY_ID: 'DELETE_EVENT_DATA_BY_ID',
  DELETE_EVENT_DATA_BY_ID_REQUEST: 'DELETE_EVENT_DATA_BY_ID_REQUEST',
  DELETE_EVENT_DATA_BY_ID_SUCCESS: 'DELETE_EVENT_DATA_BY_ID_SUCCESS',
  DELETE_EVENT_DATA_BY_ID_FAILURE: 'DELETE_EVENT_DATA_BY_ID_FAILURE',

  GET_ORGANIZERS_DATA: 'GET_ORGANIZERS_DATA',
  GET_ORGANIZERS_DATA_REQUEST: 'GET_ORGANIZERS_DATA_REQUEST',
  GET_ORGANIZERS_DATA_SUCCESS: 'GET_ORGANIZERS_DATA_SUCCESS',
  GET_ORGANIZERS_DATA_FAILURE: 'GET_ORGANIZERS_DATA_FAILURE',

  GET_ORGANIZER_DATA_BY_ID: 'GET_ORGANIZER_DATA_BY_ID',
  GET_ORGANIZER_DATA_BY_ID_REQUEST: 'GET_ORGANIZER_DATA_BY_ID_REQUEST',
  GET_ORGANIZER_DATA_BY_ID_SUCCESS: 'GET_ORGANIZER_DATA_BY_ID_SUCCESS',
  GET_ORGANIZER_DATA_BY_ID_FAILURE: 'GET_ORGANIZER_DATA_BY_ID_FAILURE',

  POST_ORGANIZER_DATA: 'POST_ORGANIZER_DATA',
  POST_ORGANIZER_DATA_REQUEST: 'POST_ORGANIZER_DATA_REQUEST',
  POST_ORGANIZER_DATA_SUCCESS: 'POST_ORGANIZER_DATA_SUCCESS',
  POST_ORGANIZER_DATA_FAILURE: 'POST_ORGANIZER_DATA_FAILURE',

  PUT_ORGANIZER_DATA: 'PUT_ORGANIZER_DATA',
  PUT_ORGANIZER_DATA_REQUEST: 'PUT_ORGANIZER_DATA_REQUEST',
  PUT_ORGANIZER_DATA_SUCCESS: 'PUT_ORGANIZER_DATA_SUCCESS',
  PUT_ORGANIZER_DATA_FAILURE: 'PUT_ORGANIZER_DATA_FAILURE',

  DELETE_ORGANIZER_DATA_BY_ID: 'DELETE_ORGANIZER_DATA_BY_ID',
  DELETE_ORGANIZER_DATA_BY_ID_REQUEST: 'DELETE_ORGANIZER_DATA_BY_ID_REQUEST',
  DELETE_ORGANIZER_DATA_BY_ID_SUCCESS: 'DELETE_ORGANIZER_DATA_BY_ID_SUCCESS',
  DELETE_ORGANIZER_DATA_BY_ID_FAILURE: 'DELETE_ORGANIZER_DATA_BY_ID_FAILURE',

  SWITCH_MENTOR_STUDENT: 'SWITCH_MENTOR_STUDENT',
  SWITCH_LAYOUT: 'SWITCH_LAYOUT',
  CHANGE_TIMEZONE: 'CHANGE_TIMEZONE',

  CHANGE_COURSE: 'CHANGE_COURSE',

  CHANGE_TYPE_COLORS: 'CHANGE_TYPE_COLORS'
};
